/**
 * @generated SignedSource<<d422f008824724c30fc0d5de421f991f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HeroCarouselImage_item$data = {
  readonly description: string | null;
  readonly " $fragmentType": "HeroCarouselImage_item";
};
export type HeroCarouselImage_item$key = {
  readonly " $data"?: HeroCarouselImage_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"HeroCarouselImage_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HeroCarouselImage_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "bf35515f99a07ee82ef2e770a9888af2";

export default node;
